module.exports = __webpack_public_path__ + "static/media/tire.22dc8903.svg";